import { render, staticRenderFns } from "./FloorPlanRoom.vue?vue&type=template&id=53d050b2&"
import script from "./FloorPlanRoom.vue?vue&type=script&lang=js&"
export * from "./FloorPlanRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports